import { WordpressPluginDTO, WordpressPluginClient, WordpressPublishDTO } from "@/Generated/ParticaAPI";

export interface IWordpressPluginService {
	get(accountId: number): Promise<WordpressPluginDTO[]>;
	save(data: WordpressPluginDTO): Promise<WordpressPluginDTO>;
	pushArticle(data: WordpressPublishDTO): Promise<any>;
	pushArticles(data: WordpressPublishDTO[]): Promise<any>;
}

export class WordpressPluginService implements IWordpressPluginService {
	private svc: WordpressPluginClient = new WordpressPluginClient();
	public async get(accountId: number): Promise<WordpressPluginDTO[]> {
		return await this.svc.getWordpressPlugins(accountId);
	}
	public async save(data: WordpressPluginDTO): Promise<WordpressPluginDTO> {
		return await this.svc.saveWordpressPlugin(data);
	}
	public async pushArticle(data: WordpressPublishDTO): Promise<any> {
		const articles: WordpressPublishDTO[] = [];
		articles.push(data);
		return await this.svc.publishToWordpress(articles);
	}
	public async pushArticles(data: WordpressPublishDTO[]): Promise<any> {
		return await this.svc.publishToWordpress(data);
	}
}
